export { ShareIcon } from './share'
